export default {
  'Approved Entries': {
    status: 'approved',
  },
  'Pending Entries': {
    status: 'pending',
  },
  'Declined Entries': {
    status: 'rejected',
  },
  'View All': {
    status: ['pending', 'approved', 'rejected'],
  },
};
